import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroNomeRelator extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Nome do Relator';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        if (registro && registro.processo && registro.processo.relator) {
            return `${registro.processo.relator.sigla}||${registro.processo.relator.cpf}||${registro.processo.relator.nome}`;
        }
    }

    getDescricao(valor) {
        if (valor) {
            return `${valor.split('||')[2]} (${valor.split('||')[0]})`;
        }
        return '';
    }
}
